import { render, staticRenderFns } from "./RankingFranchiseVariation.vue?vue&type=template&id=33453c44&"
import script from "./RankingFranchiseVariation.vue?vue&type=script&lang=js&"
export * from "./RankingFranchiseVariation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports